import {
  CompletedProgramAssessmentsDataQuery,
  useCreateProgramNoteMutation,
} from '../../generated/graphql';
import { formatFormDataForNote } from './formatFormDataForNote';
import { customToast } from '../components/ToastAlert/customToast';
import { logger } from '../../lib/logger';

export interface CreateNoteFromFormParams {
  programId: string;
  programAssessment: CompletedProgramAssessmentsDataQuery['completedProgramAssessmentsByAssessment'][number];
  patientFirstName?: string;
  createProgramNote: ReturnType<typeof useCreateProgramNoteMutation>[0];
  onSuccess?: (noteTitle: string) => void;
}

export async function createNoteFromForm({
  programId,
  programAssessment,
  patientFirstName,
  createProgramNote,
  onSuccess,
}: CreateNoteFromFormParams): Promise<void> {
  try {
    // Format the form data
    const formattedData = formatFormDataForNote(
      programAssessment,
      patientFirstName,
    );

    // Create the note
    const result = await createProgramNote({
      variables: {
        input: {
          programId,
          title: formattedData.title,
          note: formattedData.content,
        },
      },
    });

    if (result.data?.createProgramNote) {
      onSuccess?.(formattedData.title);
    }
  } catch (error) {
    logger.error('Error creating note from form', { programId, error });
    customToast.error('Unable to create note. Please try again.');
  }
}
